export default __webpack_public_path__ + "static/project-t-045b55f68506079100d12706681adfa8.jpg";